import { render, staticRenderFns } from "./create.vue?vue&type=template&id=a7072dd8&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7072dd8')) {
      api.createRecord('a7072dd8', component.options)
    } else {
      api.reload('a7072dd8', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=a7072dd8&", function () {
      api.rerender('a7072dd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/referral_programs/create.vue"
export default component.exports